var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert',{attrs:{"data-cy":"desk_not_selected"}},[_vm._v("Please select a desk to see its details.")])}
var staticRenderFns = []

export { render, staticRenderFns }